<template>
  <v-container>
    <v-card class="elevation-10">
      <v-row class="ml-2">
        <v-col
          v-for="(img, idx) in assets"
          :key="idx"
          class="d-flex child-flex"
          cols="4"
        >
          <v-img
            :src="img.src ? img.src : img"
            class="grey lighten-2"
            @click="showSelectedImage(idx)"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                />
              </v-row>
            </template>
          </v-img>
          <v-checkbox
            v-if="editEnabled || editByDefault"
            v-model="selected"
            :value="img"
          />
        </v-col>
      </v-row>
      <vue-easy-lightbox
        v-if="assets.length > 0"
        :visible="visible"
        :imgs="assets"
        :index="index"
        @hide="handleHide"
      />
      <v-file-input
        v-show="!editEnabled || editByDefault"
        v-model="newPhoto"
        chips
        show-size
        multiple
        truncate-length="8"
        accept="image/*"
        :placeholder="defaultText"
        prepend-icon="mdi-camera"
      />
      <v-btn
        v-show="!editEnabled"
        :loading="uploadingImages"
        :disabled="newPhoto === null"
        color="blue-grey"
        class="ma-2 white--text"
        @click="uploadImages"
      >
        Upload
        <v-icon
          right
          dark
        >
          mdi-cloud-upload
        </v-icon>
      </v-btn>
      <v-btn
        v-show="editEnabled || editByDefault"
        class="ml-2"
        :disabled="selected.length === 0"
        :loading="deletingImages"
        color="error"
        @click="deleteImages"
      >
        Delete Selected Images
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  name: 'PhotoComponent',
  components: {
    VueEasyLightbox,
  },
  props: {
    ownerId: {
      type: String,
      default: '',

    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
    defaultText: {
      type: String,
      default: 'Upload Additional Photos',
    },
    editByDefault: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    assets: [],
    uploadingImages: false,
    visible: false,
    selected: [],
    index: 0,
    deletingImages: false,
    newPhoto: null,
  }),
  watch: {
    ownerId() {
      if (this.ownerId) {
        this.getAssets(this.ownerId);
      }
    },
  },
  mounted() {
    this.getAssets(this.ownerId);
  },
  methods: {
    ...mapActions('apiClient', ['get', 'create', 'del']),
    handleHide() {
      this.visible = false;
    },
    async deleteImages() {
      this.deletingImages = true;

      await this.selected.reduce(async (memo, img) => {
        await memo;

        await this.del({ url: `assets/${img.id}` }).then(
          () => {
            this.assets = this.assets.filter((item) => item.id !== img.id);
          },
          (error) => {
            console.log(error);
          },
        );
      }, undefined);

      this.deletingImages = false;
      this.selected = [];

      if (this.assets.length === 0) {
        this.deleteEnabled = false;
      }
    },
    getAsset(assetId) {
      const assetUrl = `${process.env.VUE_APP_API_BASE_URL}/assets/${assetId}`;
      return assetUrl;
    },
    showSelectedImage(idx) {
      this.index = idx;
      this.visible = true;
    },
    async getAssets(ownerId) {
      await this.get({ url: `/assets/item/${ownerId}` }).then(
        (response) => {
          if (response.data.length > 0) {
            response.data.forEach((element) => {
              const assetUrl = `${process.env.VUE_APP_API_BASE_URL}/assets/${element}`;
              const a = { src: assetUrl, id: element };
              this.assets.push(a);
            });
          }
        },
        (error) => {
          console.log(error);
        },
      );
    },
    async uploadImages() {
      this.uploadingImages = true;

      this.newPhoto.forEach((photo) => {
        const formData = new FormData();
        formData.append('uploadFile', photo, photo.name);

        this.create({ url: `/assets/${this.ownerId}`, body: formData }).then(
          (response) => {
            const asset = {
              src: this.getAsset(response.data.assetId),
              id: response.data.assetId,
            };
            this.assets.push(asset);
            this.uploadingImages = false;
            this.newPhoto = null;
          },
          (error) => {
            console.log(error);
          },
        );
      });
    },
  },
};
</script>
